<template>
    <x-page title="Edit Pengunjung">
        <template #header-actions>
            <x-back-button :disabled="isLoading" />
        </template>

        <ul id="member-tabs" class="nav nav-tabs">
            <li role="presentation" class="active">
                <a href="#member-detail" aria-controls="member-detail" role="tab" data-toggle="tab">Biodata</a>
            </li>
            <li role="presentation">
                <a
                    href="#member-milestone"
                    aria-controls="member-milestone"
                    role="tab"
                    data-toggle="tab"
                    >Journey</a
                >
            </li>
        </ul>

        <div class="tab-content" style="padding-top:10px;">

            <div role="tabpanel" class="tab-pane fade in active" id="member-detail">
                <member-form id="member-form"
                    v-if="Boolean(resource)"
                    @submit="handleSubmit"
                    :display-id="true"
                    :display-join-date="false"
                    :disabled="isLoading"
                    :errors="errors"
                    :initialFields="resource" />
            </div>

            <div
                role="tabpanel"
                class="tab-pane fade section-history"
                id="member-milestone"
            >
                <member-milestones v-model="milestones" />
            </div>

        </div>

        <template #footer>
            <button
                type="button"
                class="btn btn-warning"
                :disabled="isLoading || !resource.email"
                @click="openSyncModal"
            >
                <i class="fa fa-refresh" /> Sync dari User
            </button>

            <x-submit-button
                form="member-form"
                :is-loading="isLoading"
                :disabled="isLoading"
            />
        </template>

        <sync-user-modal
            v-if="showSyncModal"
            :member="resource"
            @close="showSyncModal = false"
            @synced="handleSynced"
        />
    </x-page>
</template>

<script>
import XBackButton from '../../components/XBackButton.vue'
import XPage from '../../components/XPage.vue'
import XSubmitButton from '../../components/XSubmitButton.vue'
import { memberStatus } from '../../constants'
import { formatForDateInput, handleGeneralXhrError, handleValidationXhrError } from '../../helpers'
import FormDataMixin from '../../mixins/FormDataMixin'
import VisitorForm from './VisitorForm.vue'
import MemberGuardianForm from './MemberGuardianForm.vue'
import MemberMilestones from "../visitor/VisitorMilestones.vue";
import SyncUserModal from './SyncUserModal.vue'

export default {
    components: {
        XPage,
        XBackButton,
        XSubmitButton,
        MemberForm: VisitorForm,
        MemberGuardianForm,
        MemberMilestones,
        SyncUserModal,
    },
    created() {
        this.fetchResource()
    },
    data() {
        return {
            errors: null,
            isLoading: false,
            resource: null,
            showSyncModal: false,
        }
    },
    methods: {
        openSyncModal() {
            this.showSyncModal = true;
        },
        handleSynced(updatedMember) {
            this.resource = {
                ...updatedMember,
                birthdate: formatForDateInput(updatedMember.birthdate),
                join_date: formatForDateInput(updatedMember.join_date),
            };
            this.showSyncModal = false;
        },
        fetchResource() {
            this.isLoading = true
            const request = axios.get(`/api/visitors/${this.$route.params.id}`, {
                params: {
                    load: [
                        "milestones",
                        'user_account',
                    ],
                }
            })
            .then(response => {
                const { milestones, ...resource } = response.data.data;
                this.resource = {
                    ...resource,
                    birthdate: formatForDateInput(resource.birthdate),
                    join_date: formatForDateInput(resource.join_date),
                };
                this.milestones = [...milestones];
            })
            return handleGeneralXhrError(request).finally(() => {
                this.isLoading = false
            })
        },
        handleSubmit(fields) {
            this.isLoading = true

            fields.append('_method', 'PATCH');

            this.milestones.forEach((milestone, index) => {
                fields.append(`milestones[${index}][label]`, milestone.label);
                fields.append(
                    `milestones[${index}][description]`,
                    milestone.description
                );
                fields.append(
                    `milestones[${index}][created_at]`,
                    milestone.created_at
                );
            });

            const request = axios.post(`/api/visitors/${this.$route.params.id}`, fields, {
                headers: {
					'Content-Type': 'multipart/form-data'
				}
            })
            .then((response) => {
                this.$notify({
                    type: 'success',
                    title: `Berhasil`,
                    text: `${response.data.data.name} updated!`,
                })
                this.$router.back()
            })
            return handleValidationXhrError(request, errors => {
                this.errors = errors
                this.isLoading = false
            })
        },
    },
    mixins: [
        FormDataMixin,
    ]
}
</script>
